import { render, staticRenderFns } from "./OpenLaunchWeapp.vue?vue&type=template&id=13470098&scoped=true&"
import script from "./OpenLaunchWeapp.vue?vue&type=script&lang=js&"
export * from "./OpenLaunchWeapp.vue?vue&type=script&lang=js&"
import style0 from "./OpenLaunchWeapp.vue?vue&type=style&index=0&id=13470098&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13470098",
  null
  
)

export default component.exports